import React from 'react';
import { FaHome, FaCalendarAlt, FaPlusCircle, FaTools } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DARK = "#181b21";
const GRAY = "#b2b7be";
const BLUE = "#0b74de";
const ACTIVE_BG = "rgba(242, 244, 246, 0.12)";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const bottomNav = [
    { label: t('BottomNav.home'), icon: <FaHome />, path: '/dashboard' },
    { label: t('AddService.add_service'), icon: <FaPlusCircle />, path: '/add-service' },
    { label: t('Manage.manage'), icon: <FaTools />, path: '/manage' },
    { label: t('BottomNav.bookings'), icon: <FaCalendarAlt />, path: '/booking-calendar' }
  ];

  return (
    <div style={{
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100vw',
      background: DARK,
      borderTop: `1.5px solid ${GRAY}`,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '6px 0',
      zIndex: 100,
      boxShadow: "0 -2px 12px rgba(44,62,80,0.10)"
    }}>
      {bottomNav.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <div
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              fontSize: 12,
              color: isActive ? BLUE : '#fff',
              cursor: 'pointer',
              flex: 1,
              transition: "color 0.2s, background 0.2s",
              background: isActive ? ACTIVE_BG : "transparent",
              borderRadius: 8,
              padding: "4px 0"
            }}
          >
            <span style={{
              color: isActive ? BLUE : "#fff",
              fontSize: isActive ? 26 : 22,
              fontWeight: isActive ? 700 : 500,
              transition: "font-size 0.2s, color 0.2s"
            }}>
              {React.cloneElement(item.icon, { size: isActive ? 26 : 22 })}
            </span>
            <span style={{
              marginTop: 2,
              color: isActive ? BLUE : GRAY,
              fontWeight: isActive ? 700 : 500,
              letterSpacing: 0.2
            }}>
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}